const DefaultData = {
  APISERVERURL: "https://b2cclienttravel.azurewebsites.net/api/",
  APILOCALURL: "http://localhost:5126/api/",
  APIACTIVEURL:"https://b2cclienttravel.azurewebsites.net/api/",
  SERVICEFEE: "200",
  TENANTID: "trawtel",
  DEFAULTCOMPANYID: "efd32bd2-6639-42ed-9b1a-7e262da1be07",
  DEFAULTBRANCHID: "d6c4fbf0-f59b-4e38-a8f5-ea643ca4eaaf",
  DEFAULTUSERID: "943dc74f-1386-4baf-9861-d42cd5f4f37d",
  DEFAULTRKEY: "rzp_test_RAGPPl9FIWDkzP",
  APPLICATIONTYPE: "DEVELOPMENT",
  DEFAULTCURRENCY: "INR",
  WEBSITE: "https://trawtel.com",
  DEFAULTCOMPANYEMAIL: "support@zotrai.com",
  DEFAULTCOMPANYPHONENUMBER: "9177656344",
  DEFAULTCOMPANYGST: "36ANVPM2246A1Z0",
  DEFAULTCOMPANYNAME: "SAAR DEVELOPERS CODE PRIVATE LIMITED",
  DEFAULTBRANDNAME: "ZOTRAI",
  DEFAULTCOMPANYADDRESS: "HYDERABAD, TELANGANA",
  FACEBOOKURL: "https://www.facebook.com/zotraiapp",
  TWITTERURL: "https://x.com/zotrai",
  INSTGRAMURL: "https://www.instagram.com/zotraiapp/",
  THEMECOLOR1: "#244892",
  THEMECOLOR2: "#1a1a1a",
  THEMECOLOR3: "#ffffff",
  THEMECOLOR4: "#000000",
  THEMECOLOR5: "#84804B",
  LANDINGPAGETITLE: "AI-Powered Travel CRM for the Next Generation of Agents",
  LANDINGPAGESUBTITLE:
    "Automate, analyze, and scale your travel business with intelligent technology.",
  B2BWEBSITE: "https://b2b.trawtel.com/",
  FOOTERCOPYRIGHTS: "2010 - 2025 TRAWTEL TOURISM.",
  FOOTERSUBTITLE:
    "We make your dream more beautiful & enjoyable with lots of happiness.",
  COMPANYTYPE: "CLIENT",
  USERTYPE: "CLIENT",
  PLANTYPE: "TRIAL",
  DOMESTICFLIGHTFEE: "0",
  INTERNATIONALFLIGHTFEE: "0",
  DOMESTICHOTELBOOKINGFEE: "300",
  INTERNATIONALHOTELBOOKINGFEE: "500",
  BUSBOOKINGFEE: "50",
  INSURANCEFEE: "50",
  PaymentGatewayFee: "2",
   DEFAULTLEADCOUNT: "2",
  DEFAULTCUSTOMERCOUNT: "2",
  DEFAULTCONTACTCOUNT: "2",
  DMC_CONNECT_COST: 50,
};

export default DefaultData;